import { Box, CircularProgress } from "@mui/joy";
import IconButtonCTA from "../../common/IconButtonCTA";
import { SClose, SEdit, SSave } from "../../../styles/StyledMUI";
import { colorTokens } from "../../../styles/globalStyles";

type Props = {
  canEditBackend: boolean;
  isEditing: boolean;
  saving: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void | Promise<void>;
};

export default function SettingsSectionEditToolbar({
  canEditBackend,
  isEditing,
  saving,
  onEdit,
  onCancel,
  onSave,
}: Props) {
  if (!canEditBackend && !isEditing) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center", flexShrink: 0 }}>
      {isEditing ? (
        <>
          {saving ? (
            <CircularProgress size="sm" sx={{ color: colorTokens.accent.primary }} />
          ) : null}
          <IconButtonCTA
            ctaVariant="success"
            aria-label="Enregistrer"
            disabled={saving}
            onClick={() => void onSave()}
          >
            <SSave />
          </IconButtonCTA>
          <IconButtonCTA
            ctaVariant="accent"
            aria-label="Annuler les modifications"
            disabled={saving}
            onClick={onCancel}
          >
            <SClose />
          </IconButtonCTA>
        </>
      ) : (
        <IconButtonCTA
          ctaVariant="accent"
          aria-label="Modifier"
          disabled={!canEditBackend}
          onClick={onEdit}
        >
          <SEdit />
        </IconButtonCTA>
      )}
    </Box>
  );
}
